var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper custom-landing"},[_c('Lateral'),_c('div',{attrs:{"id":"mp"}},[_c('Section1'),_c('Section2'),_c('Section4'),_c('Section5'),_c('Section11'),_c('Section7'),_c('Section9'),_c('Section10')],1),_c('Llamadas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }